// extracted by mini-css-extract-plugin
module.exports = {"containerBg":"LegalDetail_containerBg__wLSVV","mobilePaddingX":"LegalDetail_mobilePaddingX__dfcDu"};